<div [hidden]="consulta">
    <!-- Filtros -->
    <div class="row">
        <div class="col-lg-12" style="padding: 0px">
            <section class="widget">
                <!-- título -->
                <header>
                    <h1> Aplicar evaluación  </h1>
                </header>
            </section>
        </div>
    </div>
    <div class="divisor8"></div>
    <div class="row">
        <div class="col-lg-8 col-md-6 col-sm-4 col-4">
            <div class="grupo-imagenesalumno">
              <ng-container *ngFor="let imagen of listaalumno; let i = index">

                <div class="alumnoPanel">

                    <!-- imagen -->
                    <div class="alumnoPanel__imagen" (click)="Buscaralumno(imagen)">
                        <imagenVisualizador [imagen]="imagen.foto" [verCompleta]="false" [alineacion]="AlineacionImagenEnum.ScaleAspectToFit" ></imagenVisualizador>
                    </div>

                    <div class="divisor8"></div>

                    <!-- nombre del alumno -->
                    <div class="alumnoPanel__nombre">
                        <span>{{imagen.apellidopaterno}} {{imagen.apellidomaterno}} {{ imagen.primernombre }}</span>
                    </div>
                </div>

                <!-- Insertar un divisor después de cada grupo de cinco imágenes -->
                <div class="divisoralumno" *ngIf="(i + 1) % 6 === 0"></div>
              </ng-container>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-8 col-8" style="text-align: center;">
            <div *ngIf="alumnoseleccionado">
                <div class="imagenalumnogrande">
                    <imagenVisualizador [imagen]="alumnoseleccionado.foto" [verCompleta]="false" [alineacion]="AlineacionImagenEnum.ScaleAspectToFit" ></imagenVisualizador>
                </div>
                <p>{{alumnoseleccionado.apellidopaterno}} {{alumnoseleccionado.apellidomaterno}} {{ alumnoseleccionado.primernombre }}</p>
                <button class="boton botonSM filled"
                        (click)="Formulario(alumnoseleccionado)">
                    <span> {{'Iniciar Evaluación'}}</span>
                </button>
            </div>
        </div>
    </div>
</div>

<div #containerEvaluacion></div>